<template>
  <div class="read_page page">
    <Stage :navNum="2" />
    <span class="title"
      >梦幻模拟战手游跨系统账号转移用户须知<br />请仔细阅读并在最下方确认
    </span>
    <div class="read_box">
      <span class="text_t">转移说明</span>
      <span class="text_c"
        >1、跨系统账号转移，是指帮助玩家将官方账号下的角色在安卓系统（Android）和苹果系统之间进行转移的服务</span
      >
      <span class="text_c">2、本服务仅限官方iOS和官方安卓互相转移</span>
      <span class="text_t">转移时间</span>
      <span class="text_c"
        >1、申请转移操作成功后，账号将会立即转移，您可直接在转移后平台确认转移情况</span
      >
      <span class="text_c">2、转移服务在任何时段都开放</span>
      <span class="text_t">转移账号要求</span>
      <span class="text_c">用户转移的账号需要满足以下全部条件才能转移</span>
      <span class="text_c"
        >1、本服务目前仅限<span>官方渠道</span>的玩家开放</span
      >
      <span class="text_c"
        >2、转移账号需为<span>紫龙官方手机号</span>，第三方或游客登录需绑定手机号后可转移</span
      >
      <span class="text_c">3、转移账号处于<span>未封停状态</span></span>
      <span class="text_c">4、iOS转移账号<span>未处于退款补缴状态</span></span>
      <span class="text_c"
        >5、转移账号距离上次转移时间<span>＞12小时</span></span
      >
      <span class="text_c"
        >6、转移账号未进行过<span>渠道转入官方</span>的操作</span
      >
      <span class="text_c"
        >7、转移账号未进行过<span>跨系统账号转移以外的转移服务</span></span
      >
      <span class="text_t">账号转移费用</span>
      <span class="text_c">每次进行转移需支付<span>6元</span>人民币 </span>
      <span class="text_t">账号转移流程</span>
      <span class="text_c">1、进入转移功能后，需登录验证转移账号</span>
      <span class="text_c">2、阅读用户须知</span>
      <span class="text_c">3、检测转移账号是否符合条件</span>
      <span class="text_c">4、确认转移信息及注意事项</span>
      <span class="text_c">5、完成费用支付，进行转移</span>
      <span class="text_c"
        >6、转移成功后，登录转移后的平台，确认转移情况，如有问题请联系客服QQ：800825260</span
      >
      <span class="text_c">7、转移完成后，转移账号在原平台将无法登录游戏</span>
      <span class="text_c"
        >8、转移成功后，无法撤销本次转移结果，若您想转回请等<span>12小时后</span>重新付费转移。</span
      >
      <span class="text_t">账号下角色转移的数据及范围</span>
      <span class="text_c">1、转移后，角色数据及所在服务器均不变</span>
      <span class="text_c">2、角色的所有数据都可转移</span>
      <span class="text_c"
        >3、若转移账号下有多个角色，则所有角色会一并转移</span
      >
      <span class="text_c"
        >4、若转移账号对应的目标平台已存在角色，
        则确认转移后，将覆盖目标平台账号下的角色数据</span
      >
      <span class="text_c"
        >例如：当需要从安卓转至iOS，但该账号在iOS平台账号下已有角色，则在转移流程中会进行覆盖转移的二次确认</span
      >
      <span class="text_t">特别声明</span>
      <span class="text_c"
        >1、用户按照页面操作确认后即视为知悉并接受本用户须知的全部内容。紫龙有权在必要时变更本用户须知内容，用户可在相关页面查阅最新版本的用户须知。</span
      >
      <span class="text_c"
        >2、如果用户不接受更新后的内容，请立即停止使用紫龙游戏提供的相关服务。</span
      >
      <span class="text_c"
        >3、更新后，如果用户继续使用游戏服务，即视为用户已接受变更后的用户须知。</span
      >
      <i class="text_line"></i>
      <span class="input_tip"
        >如果您确认并接受以上用户须知，请在下方输入栏中手动输入“<span>我已知悉以上须知内容和风险</span>”即可进行下一步</span
      >
      <input type="text" v-model="checkText" />
    </div>
    <div class="btn_box">
      <div class="pre_btn" @click="$parent.currentPage--">上一步</div>
      <div
        @click="nextStep"
        :class="`next_btn ${
          checkText == '我已知悉以上须知内容和风险' ? '' : 'no_next'
        }`"
      >
        已确认，下一步
      </div>
    </div>
  </div>
</template>

<script>
import Stage from './childcomponents/Stage.vue';
export default {
  components: {
    Stage
  },
  data() {
    return {
      checkText: ''
    };
  },
  computed: {},
  watch: {},
  methods: {
    nextStep() {
      if (this.checkText == '我已知悉以上须知内容和风险') {
        this.$parent.currentPage++;
      }
    }
  },
  created() {},
  mounted() {}
};
</script>
<style lang='less' scoped>
.read_page {
  .title {
    font-weight: 500;
    color: #1b1919;
    font-size: 0.32rem;
    text-align: center;
    margin-top: 0.46rem;
    margin-bottom: 0.34rem;
    flex-shrink: 0;
  }
  .read_box {
    flex-shrink: 0;
    width: 100%;
    display: flex;
    flex-direction: column;
    padding: 0 0.46rem;
    background: #feffff;
    box-sizing: border-box;
    .text_t {
      font-weight: 500;
      color: #1b1919;
      font-size: 0.28rem;
      margin-top: 0.6rem;
      margin-bottom: 0.35rem;
    }
    .text_c {
      color: #656565;
      font-size: 0.24rem;
      line-height: 0.42rem;
      span {
        color: #3e73fe;
      }
    }
    .text_line {
      width: 100%;
      height: 0.02rem;
      background: #dddede;
      opacity: 0.55;
      margin: 0.58rem 0;
    }
    .input_tip {
      color: #656565;
      font-size: 0.24rem;
      line-height: 0.42rem;
      span {
        color: #3e73fe;
      }
    }
    input {
      width: 100%;
      height: 0.9rem;
      background: #feffff;
      border: 0.02rem solid #dddede;
      border-radius: 0.2rem;
      outline: none;
      margin-top: 0.28rem;
      margin-bottom: 0.78rem;
      padding: 0 0.2rem;
      box-sizing: border-box;
    }
  }
}
</style>